// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__05z9g","spin":"Loader_spin__q0auS","rotate":"Loader_rotate__-ZsDJ","rotateccw":"Loader_rotateccw__tkJhS"};